import { Action } from "../Actions/actionRepository";
import { Trigger } from "./triggerRepository";
import * as localStorageLib from "../lib/localStorage";
import { addEvent, removeEvent } from "../lib/eventHandler";

export interface IScrollTriggerParam {
    percent: number;
}

export class ScrollTrigger implements Trigger {
    params: IScrollTriggerParam;

    constructor(params: IScrollTriggerParam) {
        this.params = params;
    }

    init = (action: Action) => {
        var fn = () => {
            let h = document.documentElement;
            let b = document.body;
            let percent = ((h.scrollTop || b.scrollTop) / ((h.scrollHeight || b.scrollHeight) - h.clientHeight)) * 100;

            if (Math.round(percent) >= this.params.percent) {
                action.execute();
            }
        };
        addEvent(window, "scroll", fn);
    };
}
